import {
  baseButtonStyles
} from "./chunk-JSCFMZUG.js";
import {
  cn,
  twVariants
} from "./chunk-LJ5F4WFH.js";

// src/IconButton/IconButton.tsx
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
var iconButtonStyles = twVariants({
  slots: {
    root: ["icon rounded-md"]
  },
  variants: {
    size: {
      sm: {
        root: "h-8 w-8 [&_svg]:h-4 [&_svg]:w-4"
      },
      md: {
        root: "h-10 w-10 [&_svg]:h-5 [&_svg]:w-5"
      },
      lg: {
        root: "h-13 w-13 [&_svg]:h-6 [&_svg]:w-6"
      }
    },
    variant: {
      ghost: {
        root: [
          "bg-transparent text-neutral-primary",
          "disabled:text-neutral-disabled disabled:hover:bg-transparent",
          "hover:bg-neutral-ghost-hovered",
          "active:bg-neutral-ghost-hovered"
        ]
      }
    }
  },
  defaultVariants: {
    size: "md",
    variant: "ghost"
  }
});
var IconButton = React.forwardRef(
  ({
    className,
    size = "md",
    variant = "ghost",
    asChild = false,
    type = "button",
    ...props
  }, ref) => {
    const Comp = asChild ? Slot : "button";
    const { root: rootButton } = baseButtonStyles();
    const { root } = iconButtonStyles({ size, variant });
    return /* @__PURE__ */ React.createElement(
      Comp,
      {
        className: cn(rootButton(), root(), className),
        ref,
        type,
        ...props
      }
    );
  }
);
IconButton.displayName = "IconButton";

export {
  iconButtonStyles,
  IconButton
};
//# sourceMappingURL=chunk-R7XHNGZL.js.map